module.exports = __webpack_public_path__ + "static/icons/icon-heart-1b67ca9c8d98a1182804f0a093e0ea3b.svg";